import { UserRoleEnumDTO } from '@auto-generated/ap-platform/users';

export type GuestPagesKeys =
	'ERROR' |
	'FRAUD' |
	'GUEST' |
	'LOGIN' |
	'REGISTER' |
	'FEEDBACK' |
	'PASSWORD_FORGOT' |
	'USER_SETTINGS' |
	'LEGAL' |
	'IMPRESSIONS' |
	'PRIVACY' |
	'TERMS_AND_CONDITIONS' |
	'CONTACT' |
	'FAQ' |
	'MULTI_FACTOR_AUTH';

export type AdminPagesKeys =
	'ADMIN' |
	'ADMIN_PROVIDER' |
	'ADMIN_PROVIDER_NEW' |
	'ADMIN_PROVIDER_USER_LIST' |
	'ADMIN_SETTING' |
	'ADMIN_PROVIDER_HISTORY' |
	'ADMIN_USER' |
	'ADMIN_USER_NEW' |
	'ADMIN_CMS' |
	'ADMIN_GENERAL';

export type ProviderPagesKeys =
	'PROVIDER' |
	'PROVIDER_SYNC_GOOGLE' |
	'PROVIDER_SYNC_OFFICE365' |
	'PROVIDER_SETTINGS' |
	'PROVIDER_PROFILE' |
	'PROVIDER_SETTINGS_DATA' |
	'PROVIDER_SETTINGS_PASSWORD' |
	'PROVIDER_SETTINGS_MFA' |
	'PROVIDER_SETTINGS_NOTIFICATION' |
	'PROVIDER_SETTINGS_SYNC' |
	'PROVIDER_CALENDAR' |
	'PROVIDER_CALENDAR_DAY' |
	'PROVIDER_CALENDAR_WEEK' |
	'PROVIDER_CALENDAR_MONTH' |
	'PROVIDER_CALENDAR_SETTINGS' |
	'PROVIDER_INFORMATION' |
	'PROVIDER_EXTRA_INFO' |
	'PROVIDER_EXPERTISE' |
	'PROVIDER_SERVICE' |
	'PROVIDER_SCHEDULE' |
  'PROVIDER_STATISTICS' |
	'PROVIDER_TREATMENT' |
	'PROVIDER_RESOURCE' |
	'PROVIDER_RESOURCE_EMPLOYEE' |
	'PROVIDER_RESOURCE_ROOM' |
	'PROVIDER_RESOURCE_DEVICE' |
	'PROVIDER_TEXT_TEMPLATE' |
	'PROVIDER_TEXT_TEMPLATE_EMAIL' |
	'PROVIDER_TEXT_TEMPLATE_SMS' |
	'PROVIDER_INSTITUTION_SETTINGS' |

	'PROVIDER_MESSAGE' |
	'PROVIDER_CONTACT' |
	'PROVIDER_FAQ' |
	'PROVIDER_IMPRESSUM' |
	'PROVIDER_PRIVACY' |
	'PROVIDER_TERMSANDCONDITIONS' |
	'PROVIDER_NEWS' |
	'PROVIDER_PATIENT' |
	'PROVIDER_PATIENT_MERGE' |
	'PROVIDER_USER_MANAGEMENT' |
	'PROVIDER_REPORTS' |
	'PROVIDER_PATIENT_WAITING_LIST' |
	'PROVIDER_INSTITUTION';

export type ResourcePagesKeys =
	'RESOURCE_LIST' |
	'RESOURCE_OVERVIEW' |
	'RESOURCE_BUSINESS_HOURS' |
	'RESOURCE_ABSENCES' |
	'RESOURCE_DATA';

export type AppointmentPagesKeys =
	'APPOINTMENT' |
	'APPOINTMENT_REQUEST_PROCESS' |
	'APPOINTMENT_REQUEST_VALIDATE' |
	'APPOINTMENT_REQUEST_RESEND' |
	'APPOINTMENT_REQUEST_RESEND_ERROR' |
	'APPOINTMENT_REQUEST_CANCELLATION' |
	'APPOINTMENT_REQUEST_CANCELLATION_RESEND' |
	'APPOINTMENT_REQUEST_DETAILS';

export type PartnerPageKeys = 'PARTNER'
export interface MenuSchema {
	title?: string;
	tooltip?: string;
	path: string;
	fullpath?: string;
	role?: Array<UserRoleEnumDTO>;
}

export const PAGE: { [key in (GuestPagesKeys | AdminPagesKeys | ProviderPagesKeys | ResourcePagesKeys | AppointmentPagesKeys | PartnerPageKeys)]: MenuSchema } = {
	ERROR: {
		path: 'error',
		fullpath: '/error'
	},
	FRAUD: {
		path: 'fraud',
		fullpath: '/fraud'
	},
	GUEST: {
		path: '',
		fullpath: '/'
	},
	LOGIN: {
		path: 'login',
		fullpath: '/login'
	},
	REGISTER: {
		path: 'register',
		fullpath: '/register'
	},
	FEEDBACK: {
		path: 'feedback',
		fullpath: '/feedback'
	},
	PASSWORD_FORGOT: {
		path: 'password-forgot',
		fullpath: '/password-forgot'
	},
	LEGAL: {
		path: 'legal',
		fullpath: '/legal'
	},
	IMPRESSIONS: {
		path: 'imprint',
		fullpath: '/provider/legal/imprint'
	},
	PRIVACY: {
		path: 'privacy',
		fullpath: '/legal/privacy'
	},
	TERMS_AND_CONDITIONS: {
		path: 'terms-and-conditions',
		fullpath: '/legal/terms-and-conditions'
	},
	CONTACT: {
		path: 'contact',
		fullpath: '/contact'
	},
	FAQ: {
		path: 'faq',
		fullpath: '/legal/faq'
	},
	USER_SETTINGS: {
		title: 'Pages.Provider.User.Settings.Title',
		path: 'user-settings',
		fullpath: '/user-settings'
	},
	MULTI_FACTOR_AUTH: {
		title: 'Pages.MFA.Title',
		path: 'multi-factor-authentication',
		fullpath: '/multi-factor-authentication'
	},
	ADMIN: {
		path: 'flamingo-admin',
		fullpath: '/flamingo-admin',
		role: [UserRoleEnumDTO.SUPERADMIN, UserRoleEnumDTO.ADMIN, UserRoleEnumDTO.CUSTOMERCARE]
	},
	ADMIN_PROVIDER: {
		path: 'provider',
		fullpath: '/flamingo-admin/provider'
	},
	ADMIN_PROVIDER_NEW: {
		path: 'new',
		fullpath: '/flamingo-admin/provider/new/_',
		role: [UserRoleEnumDTO.SUPERADMIN, UserRoleEnumDTO.ADMIN, UserRoleEnumDTO.CUSTOMERCARE]
	},
	ADMIN_PROVIDER_USER_LIST: {
		path: 'access',
		fullpath: '/flamingo-admin/provider/access'
	},
	ADMIN_SETTING: {
		path: 'settings',
		fullpath: '/flamingo-admin/settings'
	},
	ADMIN_PROVIDER_HISTORY: {
		path: 'history',
		fullpath: '/flamingo-admin/provider/history'
	},
	ADMIN_USER: {
		path: 'user',
		fullpath: '/flamingo-admin/user',
		role: [UserRoleEnumDTO.SUPERADMIN, UserRoleEnumDTO.ADMIN, UserRoleEnumDTO.CUSTOMERCARE]
	},
	ADMIN_USER_NEW: {
		path: 'new/_',
		fullpath: '/flamingo-admin/user/new/_'
	},
	ADMIN_CMS: {
		title: 'Pages.Admin.Cms.Title',
		path: 'cms',
		fullpath: '/flamingo-admin/cms',
		role: [UserRoleEnumDTO.SUPERADMIN, UserRoleEnumDTO.ADMIN]
	},
	ADMIN_GENERAL: {
		title: 'Pages.Admin.GeneralData.Title',
		path: 'general-data',
		fullpath: '/flamingo-admin/general-data',
		role: [UserRoleEnumDTO.SUPERADMIN, UserRoleEnumDTO.ADMIN]
	},
	PROVIDER: {
		title: 'Pages.Provider.Title',
		path: 'provider',
		fullpath: '/provider',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_SYNC_GOOGLE: {
		path: 'callback/google-auth'
	},
	PROVIDER_SYNC_OFFICE365: {
		path: 'callback/microsoft-auth'
	},
	PROVIDER_SETTINGS: {
		path: 'settings',
		fullpath: '/provider/settings'
	},
	PROVIDER_SETTINGS_DATA: {
		title: 'Pages.Provider.Settings.Data',
		path: 'master-data',
		fullpath: '/provider/settings/master-data'
	},
	PROVIDER_SETTINGS_PASSWORD: {
		title: 'Pages.Provider.Settings.Password',
		path: 'password',
		fullpath: '/provider/settings/password'
	},
	PROVIDER_SETTINGS_MFA: {
		title: 'Pages.Provider.Settings.MFA',
		path: 'multi-factor-authentication',
		fullpath: '/provider/settings/multi-factor-authentication'
	},
	PROVIDER_SETTINGS_NOTIFICATION: {
		title: 'Pages.Provider.Settings.Notification',
		path: 'notifications',
		fullpath: '/provider/settings/notifications'
	},
	PROVIDER_SETTINGS_SYNC: {
		title: 'Pages.Provider.Settings.Sync',
		path: 'sync',
		fullpath: '/provider/settings/sync'
	},
	PROVIDER_CALENDAR: {
		path: 'calendar',
		fullpath: '/provider/calendar',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_CALENDAR_DAY: {
		path: 'day',
		fullpath: '/provider/calendar/day',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_CALENDAR_WEEK: {
		path: 'week',
		fullpath: '/provider/calendar/week',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_CALENDAR_MONTH: {
		path: 'month',
		fullpath: '/provider/calendar/month',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_CALENDAR_SETTINGS: {
		path: 'settings',
		fullpath: '/provider/calendar/settings',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_MESSAGE: {
		path: 'messages',
		fullpath: '/provider/messages',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_PROFILE: {
		path: 'practice',
		fullpath: '/provider/practice'
	},
	PROVIDER_INFORMATION: {
		path: 'data',
		fullpath: '/provider/practice/data'
	},
	PROVIDER_EXTRA_INFO: {
		path: 'additional',
		fullpath: '/provider/practice/additional'
	},
	PROVIDER_EXPERTISE: {
		path: 'specialties',
		fullpath: '/provider/practice/specialties'
	},
	PROVIDER_SERVICE: {
		path: 'services',
		fullpath: '/provider/practice/services'
	},
	PROVIDER_SCHEDULE: {
		path: 'opening-hours',
		fullpath: '/provider/practice/opening-hours'
	},
  PROVIDER_STATISTICS: {
    path: 'statistics',
    fullpath: '/provider/practice/statistics'
  },
	PROVIDER_TREATMENT: {
		path: 'treatments',
		fullpath: '/provider/treatments',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_RESOURCE: {
		path: 'resources',
		fullpath: '/provider/resources',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_RESOURCE_EMPLOYEE: {
		path: 'employees',
		fullpath: '/provider/resources/employees',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_RESOURCE_ROOM: {
		path: 'rooms',
		fullpath: '/provider/resources/rooms',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_RESOURCE_DEVICE: {
		path: 'devices',
		fullpath: '/provider/resources/devices',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_TEXT_TEMPLATE: {
		path: 'text-templates',
		fullpath: '/provider/practice/text-templates',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_TEXT_TEMPLATE_EMAIL: {
		path: 'email',
		fullpath: '/provider/practice/email',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_TEXT_TEMPLATE_SMS: {
		path: 'sms',
		fullpath: '/provider/practice/sms',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_INSTITUTION_SETTINGS: {
		path: 'settings',
		fullpath: '/provider/practice/settings',
    role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER]
	},
	PROVIDER_CONTACT: {
		path: 'contact',
		fullpath: '/provider/contact',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER, UserRoleEnumDTO.EMPLOYEE, UserRoleEnumDTO.DEPARTMENTMANAGER, UserRoleEnumDTO.ASSISTANT]
	},
	PROVIDER_PATIENT: {
		path: 'patient-data',
		fullpath: '/provider/patient-data',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER]
	},
	PROVIDER_PATIENT_MERGE: {
		path: 'merge',
		fullpath: '/provider/patient-data/merge',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER]
	},
	PROVIDER_USER_MANAGEMENT: {
		path: 'user-management',
		fullpath: '/provider/user-management',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER]
	},
	PROVIDER_REPORTS: {
		path: 'reports',
		fullpath: '/provider/reports',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER, UserRoleEnumDTO.OFFICEMANAGER]
	},
	PROVIDER_PATIENT_WAITING_LIST: {
		path: 'waiting-list',
		fullpath: '/provider/waiting-list',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER]
	},
	PROVIDER_INSTITUTION: {
		path: 'location',
		fullpath: '/provider/location',
		role: [UserRoleEnumDTO.INSTITUTIONMANAGER]
	},
	PROVIDER_FAQ: {
		path: 'faq',
		fullpath: '/provider/faq'
	},
	PROVIDER_IMPRESSUM: {
		path: 'imprint',
		fullpath: '/provider/imprint'
	},
	PROVIDER_PRIVACY: {
		path: 'privacy',
		fullpath: '/provider/privacy'
	},
	PROVIDER_TERMSANDCONDITIONS: {
		path: 'terms-and-conditions',
		fullpath: '/provider/terms-and-conditions'
	},
	PROVIDER_NEWS: {
		path: 'news',
		fullpath: '/provider/news'
	},
	RESOURCE_LIST: {
		path: 'list'
	},
	RESOURCE_OVERVIEW: {
		path: 'overview'
	},
	RESOURCE_BUSINESS_HOURS: {
		path: 'business-hours'
	},
	RESOURCE_ABSENCES: {
		path: 'absences'
	},
	RESOURCE_DATA: {
		path: 'master-data'
	},
	APPOINTMENT: {
		path: 'appointment'
	},
	APPOINTMENT_REQUEST_PROCESS: {
		path: 'request-process'
	},
	APPOINTMENT_REQUEST_VALIDATE: {
		path: 'validate'
	},
	APPOINTMENT_REQUEST_RESEND: {
		path: 'resend'
	},
	APPOINTMENT_REQUEST_RESEND_ERROR: {
		path: 'resend-error'
	},
	APPOINTMENT_REQUEST_CANCELLATION: {
		path: 'cancellation'
	},
	APPOINTMENT_REQUEST_CANCELLATION_RESEND: {
		path: 'cancellation-resend'
	},
	APPOINTMENT_REQUEST_DETAILS: {
		path: 'details'
	},
	PARTNER: {
		path: 'partner',
		fullpath: '/partner',
		role: [UserRoleEnumDTO.REFERENT]
	}
};
